import React from 'react';
import { bool, oneOf } from 'prop-types';
import S from './style';

function Flex(properties) {
  return <S.Flex {...properties} />;
}

Flex.propTypes = {
  auto: bool,
  column: bool,
  reverse: bool,
  justify: oneOf([
    'center',
    'start',
    'end',
    'flex-start',
    'flex-end',
    'left',
    'right',
    'baseline',
    'first baseline',
    'last baseline',
    'space-between',
    'space-around',
    'space-evenly',
    'stretch',
    'safe center',
    'unsafe center',
    'initial',
    'inherit',
    'unset',
  ]),
  align: oneOf([
    'normal',
    'stretch',
    'center',
    'start',
    'end',
    'flex-start',
    'flex-end',
    'self-start',
    'self-end',
    'left',
    'right',
    'first baseline',
    'last baseline',
    'safe center',
    'unsafe center',
    'initial',
    'inherit',
    'unset',
  ]),
  wrap: oneOf([
    'nowrap',
    'wrap',
    'wrap-reverse',
    'initial',
    'inherit',
    'unset',
  ]),
};

Flex.defaultProps = {
  auto: false,
  column: false,
  reverse: false,
  justify: 'start',
  align: 'normal',
  wrap: 'inherit',
};

export default Flex;
